<h6 class="m-0" [class]="timerClass" *ngIf="isTimeBegan">
  Time Remaining
  <countdown #cd [config]="{ leftTime: timeLeft ?? 0, format: 'mm:ss', notify: [900, 600, 300, 60] }" (event)="handleEvent($event)"></countdown>
</h6>
